import { render, staticRenderFns } from "./heighrisk.vue?vue&type=template&id=29080167&scoped=true&"
import script from "./heighrisk.vue?vue&type=script&lang=js&"
export * from "./heighrisk.vue?vue&type=script&lang=js&"
import style0 from "./heighrisk.vue?vue&type=style&index=0&id=29080167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29080167",
  null
  
)

export default component.exports